module.exports = __webpack_public_path__ + "img/R.cdbe9085.png";